import React from 'react';
import {
  SvgIcon
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';




export default function HomeIconCarre(props: SvgIconProps) {
  return (
    <SvgIcon {...props} className="icon-svg" sx={{ fontSize: '1.49rem', height: 'auto' }}>

        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5279 16.0748V14.0996C15.9723 13.8794 17.2434 12.3663 17.3767 11.1842C17.7264 11.1575 18.2755 10.8365 18.4374 9.5694C18.5243 8.88893 18.1787 8.50672 17.9693 8.38623C17.9693 8.38623 18.4908 7.39565 18.4908 6.19964C18.4908 3.8017 17.5496 1.75535 15.5279 1.75535C15.5279 1.75535 14.8257 0.273926 12.5651 0.273926C8.37557 0.273926 6.63934 2.96124 6.63934 6.19964C6.63934 7.28997 7.1608 8.38623 7.1608 8.38623C6.95143 8.50672 6.60576 8.88992 6.69267 9.5694C6.85464 10.8365 7.40376 11.1575 7.75337 11.1842C7.8867 12.3663 9.15777 13.8794 9.6022 14.0996V16.0748C8.61458 19.0377 0.713623 17.0625 0.713623 23.9758H24.4165C24.4165 17.0625 16.5155 19.0377 15.5279 16.0748Z" fill="white"/>
        </svg>

    </SvgIcon>
  );
}
